import { DeliveryShipmentCostsService } from '@/core/services/delivery-shipment-costs.service'

import {
    DeliveryIndividualShipmentCostPayload,
    DeliveryIndividualStandardParamsPayload,
    GetDeliveryShipmentCostsParams,
    GetDeliveryShipmentCostsResponse,
    GetDeliveryStandardParamsParams,
    GetDeliveryStandardParamsResponse,
} from '@/core/types/delivery-shipment-costs.types'

const deliveryShipmentCostsService = new DeliveryShipmentCostsService()

class DeliveryShipmentCostsRealisation {
    getShipmentCosts(
        params: GetDeliveryShipmentCostsParams
    ): Promise<GetDeliveryShipmentCostsResponse> {
        return deliveryShipmentCostsService.getShipmentCosts(params)
    }

    getStandardParams(
        params: GetDeliveryStandardParamsParams
    ): Promise<GetDeliveryStandardParamsResponse> {
        return deliveryShipmentCostsService.getStandardParams(params)
    }

    createIndividualShipmentCost(payload: DeliveryIndividualShipmentCostPayload): Promise<void> {
        return deliveryShipmentCostsService.createIndividualShipmentCost(payload)
    }

    createIndividualStandardParams(
        payload: DeliveryIndividualStandardParamsPayload
    ): Promise<void> {
        return deliveryShipmentCostsService.createIndividualStandardParams(payload)
    }

    updateIndividualShipmentCost(payload: DeliveryIndividualShipmentCostPayload): Promise<void> {
        return deliveryShipmentCostsService.updateIndividualShipmentCost(payload)
    }

    updateIndividualStandardParams(
        payload: DeliveryIndividualStandardParamsPayload
    ): Promise<void> {
        return deliveryShipmentCostsService.updateIndividualStandardParams(payload)
    }
}

export const deliveryShipmentCosts = new DeliveryShipmentCostsRealisation()
